<template>
    <div class="templete no_print">
        <div class="path_title clearfix">
            <span class="path_title_name">组装拆卸立方差设置</span>
            <div class="contractLabel" style="position:relative;">
                <span class="redQuestion"></span>
                <div class="labelTip">
                    <div class="labelZhu">注:</div>
                    <div class="laCbelTipC">开启后，组装拆卸拆包时，待出库与待入库的码单立方差可在输入数值的范围内确认完成，此功能开启后会影响货物成本金额误差，请斟酌使用，或在完成拆包后到库存管理手动修正货物成本。</div>
                </div>
            </div>
        </div>
        <div>
            <span>组装拆卸立方差</span>
            <el-input class="input_box" v-model="orderTime" @change="timeChange" placeholder="" size="mini"></el-input>
            <!-- <span>说明: 原最低方数 100 x 超出方数 {{orderTime}} = 现最低方数 {{calValue}}</span> -->
            <!-- <span>说明: 在码单立方和检尺立方中选择其中最低方数 x [ {{orderTime}} ]  为可销售立方下限值</span> -->
        </div>
        <div class="path_switch">
            <el-radio-group v-model="radio" @change="timeChange">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
        </div>
        <div class="path_title clearfix">
            <span class="path_title_name">组装拆卸总宽度拆包设置</span>
            <div class="contractLabel" style="position:relative;">
                <span class="redQuestion"></span>
                <div class="labelTip">
                    <div class="labelZhu">注:</div>
                    <div class="laCbelTipC">非洲材/国标模板导入的数据，可选择在拆包时同步宽度明细或平分总宽度</div>
                </div>
            </div>
        </div>
        <div class="path_switch">
            <el-radio-group v-model="selectRadio" @change="selectChange">
                <el-radio :label="1">同步原包宽度明细</el-radio>
                <el-radio :label="0">平分总宽度</el-radio>
            </el-radio-group>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:15px;z-index:1;width:250px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                radio : "",
                orderTime:"",
                calValue:"",
                selectRadio:'',
            }
        },
        created(){
            this.postFunc("/erp/system.get.config",{key:"ASSEMBLY_CUBE_SUB"},res=>{
                this.radio = res.data.data.status;
                this.orderTime = res.data.data.value;
                this.calValueInput()
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("/erp/system.get.config",{key:"ASSEMBLY_WIDTH_SPLIT"},res=>{
                this.selectRadio = res.data.data.status;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        methods:{
            calValueInput(){
                this.calValue = parseFloat(100 * Number(this.orderTime)).toFixed(4);
            },
            timeChange(){
                this.postFunc("/erp/system.set.config",{key:"ASSEMBLY_CUBE_SUB",status:this.radio,value:this.orderTime},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectChange(){
                this.postFunc("/erp/system.set.config",{key:"ASSEMBLY_WIDTH_SPLIT",status:this.selectRadio},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
        }
    }
</script>
